/* =============================================================
   SLE Finishes Page — scroll-spy + RAL Classic selector
   Loaded by sections/sle-finishes-ral.liquid (single include).
   ============================================================= */
/* scroll-spy for the sticky rail */
(function () {
  var links = document.querySelectorAll('.fin-rail a[data-spy]');
  var panels = document.querySelectorAll('.fin-panel[data-panel]');
  if (!('IntersectionObserver' in window) || !links.length) return;
  var map = {};
  links.forEach(function (l) { map[l.getAttribute('data-spy')] = l; });
  var current = null;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        if (current) current.classList.remove('active');
        current = map[e.target.getAttribute('data-panel')];
        if (current) current.classList.add('active');
      }
    });
  }, { rootMargin: '-35% 0px -55% 0px' });
  panels.forEach(function (p) { io.observe(p); });
})();

/* RAL Classic selector */
(function () {
  var DATA = [
"1000|CDBA88|Green beige","1001|D0B084|Beige","1002|D2AA6D|Sand yellow","1003|F9A900|Signal yellow","1004|E49E00|Golden yellow","1005|CB8F00|Honey yellow","1006|E19000|Maize yellow","1007|E88C00|Daffodil yellow","1011|AF8050|Brown beige","1012|DDAF28|Lemon yellow","1013|E3D9C7|Oyster white","1014|DDC49B|Ivory","1015|E6D2B5|Light ivory","1016|F1DD39|Sulfur yellow","1017|F6A951|Saffron yellow","1018|FACA31|Zinc yellow","1019|A48F7A|Grey beige","1020|A08F65|Olive yellow","1021|F6B600|Colza yellow","1023|F7B500|Traffic yellow","1024|BA8F4C|Ochre yellow","1026|FFFF00|Luminous yellow","1027|A77F0F|Curry","1028|FF9C00|Melon yellow","1032|E2A300|Broom yellow","1033|F99A1D|Dahlia yellow","1034|EB9C52|Pastel yellow","1035|8F8370|Pearl beige","1036|806440|Pearl gold","1037|F09200|Sun yellow",
"2000|DA6E00|Yellow orange","2001|BA481C|Red orange","2002|BF3922|Vermilion","2003|F67829|Pastel orange","2004|E25304|Pure orange","2005|FF4D08|Luminous orange","2007|FFB200|Luminous bright orange","2008|EC6B22|Bright red orange","2009|DE5308|Traffic orange","2010|D05D29|Signal orange","2011|E26E0F|Deep orange","2012|D5654E|Salmon orange","2013|923E25|Pearl orange","2017|FC5500|RAL orange",
"3000|A72920|Flame red","3001|9B2423|Signal red","3002|9B2321|Carmine red","3003|861A22|Ruby red","3004|6B1C23|Purple red","3005|59191F|Wine red","3007|3E2022|Black red","3009|6D342D|Oxide red","3011|782423|Brown red","3012|C5856D|Beige red","3013|972E25|Tomato red","3014|CB7375|Antique pink","3015|D8A0A6|Light pink","3016|A63D30|Coral red","3017|CA555D|Rose","3018|C63F4A|Strawberry red","3020|BB1F11|Traffic red","3022|CF6955|Salmon pink","3024|FF2D21|Luminous red","3026|FF2A1C|Luminous bright red","3027|AB273C|Raspberry red","3028|CC2C24|Pure red","3031|A63437|Orient red","3032|701D24|Pearl ruby red","3033|A53A2E|Pearl pink",
"4001|816183|Red lilac","4002|8D3C4B|Red violet","4003|C4618C|Heather violet","4004|651E38|Claret violet","4005|76689A|Blue lilac","4006|903373|Traffic purple","4007|47243C|Purple violet","4008|844C82|Signal violet","4009|9D8692|Pastel violet","4010|BB4077|Telemagenta","4011|6E6387|Pearl violet","4012|6A6B7F|Pearl blackberry",
"5000|304F6E|Violet blue","5001|0E4C64|Green blue","5002|00387A|Ultramarine blue","5003|1F3855|Sapphire blue","5004|191E28|Black blue","5005|005387|Signal blue","5007|376B8C|Brilliant blue","5008|2B3A44|Grey blue","5009|215F78|Azure blue","5010|004F7C|Gentian blue","5011|1A2B3C|Steel blue","5012|0089B6|Light blue","5013|193153|Cobalt blue","5014|637D96|Pigeon blue","5015|007CAF|Sky blue","5017|005B8C|Traffic blue","5018|048B8C|Turquoise blue","5019|005E83|Capri blue","5020|00414B|Ocean blue","5021|007577|Water blue","5022|222D5A|Night blue","5023|41698C|Distant blue","5024|6093AC|Pastel blue","5025|20697C|Pearl gentian blue","5026|0F3052|Pearl night blue",
"6000|3C7460|Patina green","6001|366735|Emerald green","6002|325928|Leaf green","6003|50533C|Olive green","6004|024442|Blue green","6005|114232|Moss green","6006|3C392E|Grey olive","6007|2C3222|Bottle green","6008|36342A|Brown green","6009|27352A|Fir green","6010|4D6F39|Grass green","6011|6B7C59|Reseda green","6012|2F3D3A|Black green","6013|7C765A|Reed green","6014|474135|Yellow olive","6015|3D3D36|Black olive","6016|00694C|Turquoise green","6017|587F40|May green","6018|60993B|Yellow green","6019|B9CEAC|Pastel green","6020|37422F|Chrome green","6021|8A9977|Pale green","6022|3A3327|Olive drab","6024|008351|Traffic green","6025|5E6E3B|Fern green","6026|005F4E|Opal green","6027|7EBAB5|Light green","6028|315442|Pine green","6029|006F3D|Mint green","6032|237F52|Signal green","6033|45877F|Mint turquoise","6034|7AADAC|Pastel turquoise","6035|194D25|Pearl green","6036|04574B|Pearl opal green","6037|008B29|Pure green","6038|00B51B|Luminous green","6039|B3C43E|Fibrous green",
"7000|7A888E|Squirrel grey","7001|8C979C|Silver grey","7002|817863|Olive grey","7003|797669|Moss grey","7004|9A9B9B|Signal grey","7005|6B6E6B|Mouse grey","7006|766A5E|Beige grey","7008|745F3D|Khaki grey","7009|5D6058|Green grey","7010|585C56|Tarpaulin grey","7011|52595D|Iron grey","7012|575D5E|Basalt grey","7013|575044|Brown grey","7015|4F5358|Slate grey","7016|383E42|Anthracite grey","7021|2F3234|Black grey","7022|4C4A44|Umbra grey","7023|808076|Concrete grey","7024|45494E|Graphite grey","7026|374345|Granite grey","7030|928E85|Stone grey","7031|5B686D|Blue grey","7032|B5B0A1|Pebble grey","7033|7F8274|Cement grey","7034|92886F|Yellow grey","7035|C5C7C4|Light grey","7036|979392|Platinum grey","7037|7A7B7A|Dusty grey","7038|B0B0A9|Agate grey","7039|6B665E|Quartz grey","7040|989EA1|Window grey","7042|8E9291|Traffic grey A","7043|4F5250|Traffic grey B","7044|B7B3A8|Silk grey","7045|8D9295|Telegrey 1","7046|7E868A|Telegrey 2","7047|C8C8C7|Telegrey 4","7048|817B73|Pearl mouse grey",
"8000|89693F|Green brown","8001|9D622B|Ochre brown","8002|794D3E|Signal brown","8003|7E4B27|Clay brown","8004|8D4931|Copper brown","8007|70462B|Fawn brown","8008|724A25|Olive brown","8011|5A3827|Nut brown","8012|66332B|Red brown","8014|4A3526|Sepia brown","8015|5E2F26|Chestnut brown","8016|4C2B20|Mahogany brown","8017|442F29|Chocolate brown","8019|3D3635|Grey brown","8022|1A1719|Black brown","8023|A45729|Orange brown","8024|795038|Beige brown","8025|755847|Pale brown","8028|513A2A|Terra brown","8029|7F4031|Pearl copper",
"9001|E9E0D2|Cream","9002|D6D5CB|Grey white","9003|ECECE7|Signal white","9004|2B2B2C|Signal black","9005|0E0E10|Jet black","9006|A1A1A0|White aluminium","9007|868581|Grey aluminium","9010|F1EDE1|Pure white","9011|27292B|Graphite black","9012|F8F2E1|Cleanroom white","9016|F1F1EA|Traffic white","9017|29292A|Traffic black","9018|C8CBC4|Papyrus white","9022|858583|Pearl light grey","9023|787B7A|Pearl dark grey"
  ].map(function (s) {
    var p = s.split('|');
    return { code: p[0], hex: '#' + p[1], name: p[2] };
  });

  var grid = document.getElementById('ralGrid');
  var count = document.getElementById('ralCount');
  var search = document.getElementById('ralSearch');
  var fams = document.getElementById('ralFams');
  if (!grid) return;

  var state = { fam: 'all', q: '', selected: null };

  function applyColor(c) {
    state.selected = c;
    ['ralShade', 'ralStem', 'ralRim', 'ralCanopy'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.setAttribute('fill', c.hex);
    });
    if (window.sleViewer) window.sleViewer.setColor(c.hex);
    document.getElementById('ralCode').textContent = 'RAL ' + c.code;
    document.getElementById('ralName').textContent = c.name;
    document.getElementById('ralHex').textContent = c.hex;
    document.getElementById('ralRequest').href =
      'mailto:info@southernlightselectric.com?subject=' +
      encodeURIComponent('Custom powdercoat — RAL ' + c.code + ' ' + c.name);
    grid.querySelectorAll('button[aria-current]').forEach(function (b) {
      b.removeAttribute('aria-current');
    });
    var btn = grid.querySelector('button[data-code="' + c.code + '"]');
    if (btn) btn.setAttribute('aria-current', 'true');
  }

  function visible() {
    return DATA.filter(function (c) {
      if (state.fam !== 'all' && c.code.charAt(0) !== state.fam) return false;
      if (state.q) {
        var q = state.q.toLowerCase();
        if (c.code.indexOf(q) === -1 && c.name.toLowerCase().indexOf(q) === -1) return false;
      }
      return true;
    });
  }

  function render() {
    var rows = visible();
    grid.innerHTML = '';
    rows.forEach(function (c) {
      var b = document.createElement('button');
      b.type = 'button';
      b.style.background = c.hex;
      b.setAttribute('data-code', c.code);
      b.setAttribute('role', 'option');
      b.title = 'RAL ' + c.code + ' — ' + c.name;
      b.setAttribute('aria-label', 'RAL ' + c.code + ' ' + c.name);
      if (state.selected && state.selected.code === c.code) b.setAttribute('aria-current', 'true');
      b.addEventListener('click', function () {
        applyColor(c);
      });
      grid.appendChild(b);
    });
    if (!rows.length) {
      var d = document.createElement('div');
      d.className = 'empty';
      d.textContent = 'No matches — try a RAL number (e.g. 5020) or a color word.';
      grid.appendChild(d);
    }
    count.textContent = rows.length + ' of ' + DATA.length + ' colors';
  }

  fams.addEventListener('click', function (e) {
    var btn = e.target.closest('button[data-fam]');
    if (!btn) return;
    state.fam = btn.getAttribute('data-fam');
    fams.querySelectorAll('button').forEach(function (b) { b.classList.remove('on'); });
    btn.classList.add('on');
    render();
  });

  search.addEventListener('input', function () {
    state.q = search.value.trim();
    render();
  });

  document.getElementById('ralCopy').addEventListener('click', function () {
    if (!state.selected) return;
    var c = state.selected;
    var text = 'RAL ' + c.code + ' ' + c.name + ' (' + c.hex + ')';
    var btn = this;
    function done() {
      btn.textContent = 'Copied';
      setTimeout(function () { btn.textContent = 'Copy color'; }, 1400);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, done);
    } else { done(); }
  });

  render();
  applyColor(DATA.filter(function (c) { return c.code === '2012'; })[0] || DATA[0]);
})();

